// src/common/components/LoadingScreen/LoadingScreen.tsx
import React from "react";
import styles from "./LoadingScreen.module.scss";
import { useTheme } from "../../../common/hooks/useTheme";

export const LoadingScreen: React.FC = () => {
  const { theme } = useTheme();

  return (
    <div
      className={styles.container}
      style={{ backgroundColor: theme.background }}
    >
      <div className={styles.loader}>
        <div
          className={styles.spinner}
          // style={{ borderTopColor: theme.primary }}
        />
      </div>
    </div>
  );
};
